export BlockText from './BlockText'
export BlockMedia from './BlockMedia'
export BlockPullQuote from './BlockPullQuote'
export BlockCarousel from './BlockCarousel'
export BlockHeading from './BlockHeading'
export BlockSectionOpening from './BlockSectionOpening'
export BlockVideoPlayer from './BlockVideoPlayer'
export BlockTextMedia from './BlockTextMedia'
export BlockCaseStudy from './BlockCaseStudy'
export BlockRecentProjects from './BlockRecentProjects'
export BlockJournal from './BlockJournal'
export BlockContact from './BlockContact'
export BlockSignUp from './BlockSignUp'


// WEBPACK FOOTER //
// ./src/components/Block/templates/index.js